<template>
  <div class="container">
    <img :src="templateImage"  ref="imageElement"  @load="loadImage" class="drawImage">
    <!-- 生成的矩形 -->
    <div @keydown="handleKeyDown">
      <vue-drag-resize
        v-for="(rect, index) in location"
        :key="rect.id"
        :w="rect.width"
        :h="rect.height"
        :x="rect.left"
        :y="rect.top"
        :minh="10"
        :minw="10"
        :isActive="false" 
        :isDraggable="false"
        :isResizable="false"
      >
      <!--拖拽框显示最小高宽为10px  -->

      <!-- 自定义矩形框 -->
      <div class="rectangle" >
        <span class="top-left-m" v-if="rect.type == 'absentMark' || rect.type == 'cheatMark'"> {{ rect.title }} </span> 
        <span class="top-left" v-else> {{ rect.title }} </span> 
        <!-- <canvas :id="'pc_'+rect.id"></canvas> -->
         <canvas :id="'pc_'+index"></canvas>
      </div>
      </vue-drag-resize>
    </div>
  
    <div>
  </div>
  
  </div>
  
</template>
  <script>
  import {mapState, mapMutations, mapGetters} from 'vuex';
  import XEUtils from 'xe-utils'
  import * as simpleApi from "request/simple";
  import * as mUtils from '@/utils/mUtils'
  import VueDragResize from 'vue-drag-resize';

  export default {
      name: 'other',
      computed: {
      },
      props: {
      },
      components:{
        VueDragResize
  
      },
      watch: {
  
      },
      data() {
        return {
          // templateA: 'https://dev-vknow-admin.obs.cn-east-3.myhuaweicloud.com/手工补录/4740/20250307093845997/1010.png',
          // templateA: 'https://dev-vknow-admin.obs.cn-east-3.myhuaweicloud.com/手工补录/4740/20250307093426581/1.png',
          templateImage: null,
          scantronInfo: null,
          scanPre: null,
          // 答题卡页码（0： 正面，1：背面）
          pageNo: 0,
          currentWidth:0,
          currentHeight:0,
          image_width: null, 
          image_height: null,
          location:[],
          // 正反面答题卡信息
          pageB: [],
          pageA: [],
          result: [],
          // 图片偏移位置
          offsetLeft: 0,
          offsetTop: 0,
          percent: {
              "P2": [[0.4341085271317829416663750, 0.748062015503875991667], [0.748062015503875991667, 1]], 
              // "P2": [[0.2, 0.6], [0.6, 1]], 
              // "PD2": [[0.37184693, 0.689799434], [0.689799434, 1]],
              "PD2": [[0.433821418333, 0.73459296629632963], [0.70141708708336667, 1]],
              "P3": [[0.353982300884955750000, 0.5693215339233038333333333],
                [0.5693215339233038333333333, 0.7846607669616519166666666], 
                [0.7846607669616519166666666, 1]],
              // 0.8
              // "P4": [[0.2857142857142857000000, 0.4595238095238095133333333], [0.4595238095238095133333333,0.6333333333333333266666666], [0.6333333333333333266666666, 0.8071428571428571399999999], [0.8071428571428571399999999, 1]],
              // 0.75
              "P4": [[0.2857142857142857000000, 0.46428571428571427500000000],
              [0.46428571428571427500000000,0.64285714285714285000000000], 
              [0.64285714285714285000000000, 0.82142857142857142500000000], 
              [0.82142857142857142500000000, 1]],
              
              "P5": [[0.2395209580838323500000, 0.39161676646706588000000000], 
              [0.39161676646706588000000000, 0.54371257485029941000000000],
                [0.54371257485029941000000000, 0.69580838323353294000000000],
                [0.69580838323353294000000000, 0.84790419161676647000000000], 
                [0.84790419161676647000000000 , 1]],
                
              "P6": [[0.2061855670103092750000, 0.33848797250859106250000000], 
              [0.33848797250859106250000000, 0.47079037800687285000000000],
                [0.47079037800687285000000000, 0.60309278350515463750000000], 
                [0.60309278350515463750000000, 0.73539518900343642500000000], 
                [0.73539518900343642500000000,0.86769759450171821250000000], 
                [0.86769759450171821250000000, 1]],


              "P7": [[0.1809954751131221875000, 0.29799612152553330357142857],
                [0.29799612152553330357142857, 0.41499676793794441964285714],
                [0.41499676793794441964285714,0.53199741435035553571428571],
                  [0.53199741435035553571428571, 0.64899806076276665178571428],
                  [0.64899806076276665178571428,  0.76599870717517776785714285],
                    [0.76599870717517776785714285,  0.88299935358758888392857142],
                    [0.88299935358758888392857142, 1]],


              "P8": [[0.1612903225806451625000, 0.26612903225806451718750000],
                [0.26612903225806451718750000, 0.37096774193548387187500000],
                [0.37096774193548387187500000,  0.47580645161290322656250000],
                  [0.47580645161290322656250000,  0.58064516129032258125000000],
                  [0.58064516129032258125000000,  0.68548387096774193593750000],
                    [0.68548387096774193593750000,  0.79032258064516129062500000],
                    [0.79032258064516129062500000, 0.89516129032258064531250000],
                      [0.89516129032258064531250000, 1]],


                      
              "P9": [[0.1454545454545454500000,0.24040404040404040000000000],
                [0.24040404040404040000000000 ,  0.33535353535353535000000000],
                [0.33535353535353535000000000, 0.43030303030303030000000000],
                  [0.43030303030303030000000000,  0.52525252525252525000000000],
                  [0.52525252525252525000000000,  0.62020202020202020000000000],
                    [0.62020202020202020000000000, 0.71515151515151515000000000],
                    [0.71515151515151515000000000,  0.81010101010101010000000000],
                      [0.81010101010101010000000000,  0.90505050505050505000000000],
                      [0.90505050505050505000000000, 1]],


              "P10": [[0.1324503311258278125000,  0.21920529801324503125000000],
                [0.21920529801324503125000000, 0.30596026490066225000000000], //B
                [0.30596026490066225000000000, 0.39271523178807946875000000],
                [0.39271523178807946875000000,  0.47947019867549668750000000], //D
                [0.47947019867549668750000000, 0.56622516556291390625000000],
                [0.56622516556291390625000000,  0.65298013245033112500000000], //F
                [0.65298013245033112500000000,  0.73973509933774834375000000],

                [0.73973509933774834375000000,  0.843841059602649006250000000], //H
                [0.843841059602649006250000000,  0.91324503311258278125000000],
                [0.91324503311258278125000000, 1]],

              //   [0.73973509933774834375000000,  0.82649006622516556250000000], //H
              //   [0.82649006622516556250000000,  0.91324503311258278125000000],
              //   [0.91324503311258278125000000, 1]],



            "P11": [[0.121580547112462000000, 0.2014368610113290909090909], 
            [0.2014368610113290909090909, 0.2812931749101961818181818],
              [0.2812931749101961818181818, 0.3611494888090632727272727], 
              [0.3611494888090632727272727,0.4410058027079303636363636], 
              [0.4410058027079303636363636, 0.5208621166067974545454545], 
              [0.5208621166067974545454545, 0.6007184305056645454545454 ],
              [0.6007184305056645454545454,  0.6805747444045316363636363], 

              [0.6805747444045316363636363, 0.77640232108317214545454538], 
              [0.77640232108317214545454538,  0.84028737220226581818181810], 
              [0.84028737220226581818181810,  0.916150870406189554545454455], 
              [0.916150870406189554545454455, 1]],

              // [0.6805747444045316363636363, 0.7604310583033987272727272], 
              // [0.7604310583033987272727272,  0.8402873722022658181818181], 
              // [0.8402873722022658181818181,  0.9201436861011329090909090], 
              // [0.9201436861011329090909090, 1]],



            "P12": [[0.112359550561797750000, 0.1863295880149812708333333],  //A
              [0.1863295880149812708333333, 0.2602996254681647916666666], //B
              [0.2602996254681647916666666,  0.3342696629213483124999999],
              [0.3342696629213483124999999,  0.4082397003745318333333332], //D
              [0.4082397003745318333333332,  0.4822097378277153541666665],
              [0.4822097378277153541666665, 0.5561797752808988749999998], //F
              [0.5561797752808988749999998,  0.6301498127340823958333331],

              [0.6301498127340823958333331,  0.71891385767790262083333306], //H
              [0.71891385767790262083333306,  0.77808988764044943749999970],
              [0.77808988764044943749999970,  0.848361423220973782291666335], //J
              [0.848361423220973782291666335,  0.922331460674157303124999635],
              [0.922331460674157303124999635, 1]],

              // [0.6301498127340823958333331,  0.7041198501872659166666664], //H
              // [0.7041198501872659166666664,  0.7780898876404494374999997],
              // [0.7780898876404494374999997,  0.8520599250936329583333330], //J
              // [0.8520599250936329583333330,  0.9260299625468164791666663],
              // [0.9260299625468164791666663, 1]],


              "P13": [[0.104438642297650125000, 0.1733279775055231923076923],  //A
              [0.1733279775055231923076923,  0.2422173127133962596153846], //B
              [0.2422173127133962596153846,  0.3111066479212693269230769],
              [0.3111066479212693269230769, 0.3799959831291423942307692], //D
              [0.3799959831291423942307692,  0.4488853183370154615384615],
              [0.4488853183370154615384615,  0.5177746535448885288461538], //F
              [0.5177746535448885288461538,  0.5866639887527615961538461],

              [0.5866639887527615961538461, 0.66933119100220927692307686], //H
              [0.66933119100220927692307686,  0.72444265916850773076923070],
              [0.72444265916850773076923070,  0.789887527615987144711538385], //J
              [0.789887527615987144711538385, 0.858776862823860212019230685],
              [0.858776862823860212019230685,   0.927666198031733279326922985],
              [0.927666198031733279326922985, 1]],

              // [0.5866639887527615961538461, 0.6555533239606346634615384], //H
              // [0.6555533239606346634615384,  0.7244426591685077307692307],
              // [0.7244426591685077307692307,  0.7933319943763807980769230], //J
              // [0.7933319943763807980769230, 0.8622213295842538653846153],
              // [0.8622213295842538653846153,  0.9311106647921269326923076],
              // [0.9311106647921269326923076, 1]],



              "P14": [[0.0975609756097561000000,  0.16202090592334495000000000],  //A
              [0.16202090592334495000000000, 0.22648083623693380000000000 ], //B
              [0.22648083623693380000000000,  0.29094076655052265000000000],
              [0.29094076655052265000000000,  0.35540069686411150000000000], //D
              [0.35540069686411150000000000, 0.41986062717770035000000000 ],
              [0.41986062717770035000000000,  0.48432055749128920000000000], //F
              [0.48432055749128920000000000,  0.54878048780487805000000000],
              

              [0.54878048780487805000000000,  0.626132404181184670000000000], //H
              [0.626132404181184670000000000,  0.67770034843205575000000000],
              [0.67770034843205575000000000,  0.7389372822299651575000000000], //J
              [0.7389372822299651575000000000,  0.8033972125435540075000000000],
              [0.8033972125435540075000000000,   0.8678571428571428575000000000],
              [0.8678571428571428575000000000,  0.9323170731707317075000000000],
              [0.9323170731707317075000000000, 1]],

              // [0.54878048780487805000000000,  0.61324041811846690000000000], //H
              // [0.61324041811846690000000000,  0.67770034843205575000000000],
              // [0.67770034843205575000000000,  0.74216027874564460000000000], //J
              // [0.74216027874564460000000000,  0.80662020905923345000000000],
              // [0.80662020905923345000000000,  0.87108013937282230000000000],
              // [0.87108013937282230000000000,  0.93554006968641115000000000],
              // [0.93554006968641115000000000, 1]],


              "P15": [[0.0915331807780320375000, 0.15209763539282990166666667],  //A
              [0.15209763539282990166666667,  0.21266209000762776583333334], //B
              [0.21266209000762776583333334,  0.27322654462242563000000001],
              [0.27322654462242563000000001,  0.33379099923722349416666668], //D
              [0.33379099923722349416666668,  0.39435545385202135833333335],
              [0.39435545385202135833333335,  0.45491990846681922250000002], //F
              [0.45491990846681922250000002, 0.51548436308161708666666669 ],
              
              [0.51548436308161708666666669,  0.588161708619374523666666694], //H
              [0.588161708619374523666666694,  0.63661327231121281500000003],
              [0.63661327231121281500000003, 0.691121281464530892750000033 ], //J
              [0.691121281464530892750000033, 0.751685736079328756916666703 ],
              [0.751685736079328756916666703, 0.812250190694126621083333373],
              [0.812250190694126621083333373, 0.872814645308924485250000043],
              [0.872814645308924485250000043, 0.933379099923722349416666713],
              [0.933379099923722349416666713, 1]],

              // [0.51548436308161708666666669,  0.57604881769641495083333336], //H
              // [0.57604881769641495083333336,  0.63661327231121281500000003],
              // [0.63661327231121281500000003, 0.69717772692601067916666670 ], //J
              // [0.69717772692601067916666670,  0.75774218154080854333333337],
              // [0.75774218154080854333333337,  0.81830663615560640750000004],
              // [0.81830663615560640750000004, 0.87887109077040427166666671],
              // [0.87887109077040427166666671, 0.93943554538520213583333338 ],
              // [0.93943554538520213583333338, 1]],
              
          },
          w_sc: 1,
          h_sc: 1,
          isActive: null,
          // 每次挪5像素
          step:1,
          // 加载json 是否成功
          loadingJson: false,
          scantronType: -1
        }
      },
      mounted() {
        // 让容器获取焦点，以便监听键盘事件
        window.addEventListener('keydown', this.handleKeyDown);
      },
      created(){
        // 加载图片
        this.$nextTick(() => {
          this.drawScantron()
        })
        
        // this.getJsonByLocation()

      },
      watch:{
        scanPre: {
          // async handler(newValue,oldValue){
           handler(newValue,oldValue){

            // this.templateImage = newValue.oss_full_name
            // this.templateImage = mUtils.urlAddTimestamp(mUtils.changeSpecialCode(newValue.oss_name,newValue.oss_full_name));
            this.location = []
            this.pageA = []
            this.pageB = []
            // 判断是否清空，清空数据
            if(newValue.ossName == null || newValue.ossName == undefined || newValue.ossName == ''){
              this.templateImage = null
            }else {
              this.templateImage = mUtils.urlAddTimestamp(mUtils.changeSpecialCode(newValue.ossName,newValue.ossFullName));
              // this.templateImage = await mUtils.urlAddTimestamp(await mUtils.changeSpecialCode(newValue.cutOssName,newValue.cutOssFullName));
            }
          },
          // immediate: true
        }
      },
      methods: { 
        // 手工切图
        drawScantron(val){
          let param = { controllerName: 'exam/scantron', methodName: '/getSheetByExamId', param: { examId: this.scanPre.exam_id}};
            simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {

              this.scantronInfo = data
              // this.$nextTick(() => {
                this.getJsonByLocation()
              // })
              
            });
        },
        // 加载图片
        loadImage(){

          const imgElement = this.$refs.imageElement;  

          // 获取图片的自然宽度和高度  
          const naturalWidth = imgElement.naturalWidth;  
          const naturalHeight = imgElement.naturalHeight;  
          
          // 获取图片的显示宽度和高度  
          const currentWidth = imgElement.clientWidth;  
          const currentHeight = imgElement.clientHeight;  

          // 获取显示高宽与自然高宽的比例
          this.w_sc = currentWidth / naturalWidth
          this.h_sc = currentHeight / naturalHeight

          // 获取图片的位置  (初始位置 - 偏移位置)
          this.offsetTop = imgElement.offsetTop;  
          this.offsetLeft = imgElement.offsetLeft; 
          // 获取图片边缘
          const rect = imgElement.getBoundingClientRect(); // 获取边界矩形 
          // this.offsetTop = rect.top;  
          // this.offsetLeft = rect.left; 

          this.currentWidth = currentWidth
          this.currentHeight = currentHeight
          
          this.image_width = currentWidth 
          this.image_height = currentHeight

          this.$nextTick(() => {
            // this.getJsonByLocation()

            this.draw()
          })
        },
        // 绘画进度
        async  draw(){

          await this.getJsonByLocation()
          // await this.getJsonByChoose()
          // await this.getJsonByStudentNo()

        },
        // 获取json文件中的位置信息
        getJsonByLocation(){

          // 获取位置信息
          let location = JSON.parse(this.scantronInfo.location)
          console.log(location);
          let  pageSheets = location.pageSheets
          pageSheets.forEach((element,index) => {

            if(index !== 1){
              let postions = []
              // 题区的顺序（从0开始）
              let code = 0

              // let postion = this.pageA
              // let preImage = this.preImageA

              // 计算答题卡与显示图片的比例
              // 判断图片是否加载成功，未成功则提示答题卡加载中
              console.log('----------------------------------');
              this.loadingJson = this.image_width == null || this.image_height == null ? false : true
              console.log(this.image_width);
              console.log(this.image_height);
              console.log(this.loadingJson);
              console.log('===========================');
              this.width_sc = this.image_width / this.scantronInfo.imageWidth 
              this.height_sc =  this.image_height  / this.scantronInfo.imageHeight 

              // 获取题目位置信息
              let sections = element.sections
              let selectList =[]
              sections.forEach((element,index) => {
   
                let title = "第"+ (index + 1) + "题区"
                let id = index
                // 判断是否是选择题，是选择题的话需要另外渲染选择框
                let type = element.type
                let a = element.contents.position
                // 题块位置信息
                let point = {
                  id: id,
                  index: index,
                  title: title,
                  type: type,
                  left: a.left * this.width_sc + this.offsetLeft -18,
                  top: a.top * this.height_sc + this.offsetTop -12*2,

                  // left: element.left * this.width_sc + this.offsetLeft -18,
                  // top: element.top * this.height_sc  -12*2  , 

                  height: a.height * this.height_sc,
                  width: a.width * this.width_sc,
                  // 携带题号信息
                  branch: element.contents.branch,
                  // 获得换算过的高宽
                  width_old: a.width * this.width_sc,
                  height_old: a.height * this.height_sc,
                  scantron_width: a.width,
                  scantron_height: a.height
                }
                // postions.push(a)
                // 题区顺序 +1
                code ++
                postions.push(point)
                // selectList.push(point)
              });
              // postMap.sections = selectList
              // 获取条形码学号
              if("barCode" in element){
                let position = element.barCode.position

                let point = {
                  id: code,
                  type: 'barCode',
                  title:'学号',
                  left: position.left * this.width_sc + this.offsetLeft,
                  top: position.top * this.height_sc + this.offsetTop,
                  height: position.height * this.height_sc,
                  width: position.width * this.width_sc,
                  scantron_width: position.width,
                  scantron_height: position.height
                }
                code ++
                postions.push(point)
              }

              // 获得学号
              if("ticketNum" in element){
                let ticketNum = element.ticketNum
                let position = element.ticketNum.position
                let point = {
                  id: code,
                  type: 'ticketNum',
                  title:'学号',
                  count: ticketNum.count,
                  left: position.left * this.width_sc + this.offsetLeft,
                  top: position.top * this.height_sc + this.offsetTop,
                  height: position.height * this.height_sc,
                  width: position.width * this.width_sc,
                  // 头个选项位置
                  firstOption: ticketNum.firstOption,
                  // 获得换算过的高宽
                  width_old: position.width * this.width_sc,
                  height_old: position.height * this.height_sc,
                  scantron_width: position.width,
                  scantron_height: position.height
                }
                code ++
                postions.push(point)
              }

              // 获取作弊标识
              if("cheatMark" in element){
                let position = element.cheatMark.position

                let point = {
                  id: code,
                  type:'cheatMark',
                  title:'作弊',
                  left: position.left * this.width_sc + this.offsetLeft,
                  top: position.top * this.height_sc + this.offsetTop,
                  height: position.height* this.height_sc,
                  width: position.width * this.width_sc,
                  scantron_width: position.width,
                  scantron_height: position.height
                }
                code ++
                postions.push(point)
              }

              // 获取缺考标识
              if("absentMark" in element){
                let position = element.absentMark.position

                let point = {
                  id: code,
                  type:'absentMark',
                  title:'缺考',
                  left: position.left * this.width_sc + this.offsetLeft,
                  top: position.top * this.height_sc + this.offsetTop,
                  height: position.height* this.height_sc,
                  width: position.width * this.width_sc,
                  scantron_width: position.width,
                  scantron_height: position.height

                  // left: 20,
                  // top: 0,
                  // height: 820.5,
                  // width: 800

                }
                code ++
                postions.push(point)
              }

              // 定位点弄出来看看
              // let locatePoint = element.locatePoint
              // locatePoint.forEach(element => {
         
              //   let point = {
              //     id: code,
              //     type:'point',
              //     title:'_',
              //     // left:( element.left * this.width_sc + this.offsetLeft  ) ,
              //     // top: (element.top * this.height_sc + this.offsetTop ) ,
              //     // left :x 
              //     // top:y
              //     left: element.left * this.width_sc + this.offsetLeft -18,
              //     top: element.top * this.height_sc  -12*2  ,

              //     height: element.height* this.height_sc,
              //     width: element.width * this.width_sc
              //   }
              //   code ++
              //   postions.push(point)
              // });

              // 获取学号
              this.pageA = postions
            }else{
              let postions = []
              // 题区的顺序（从0开始）
              let code = 0

              // 计算答题卡与显示图片的比例
              this.width_sc = this.image_width / this.scantronInfo.imageWidth 
              this.height_sc =  this.image_height  / this.scantronInfo.imageHeight 

              // 获取题目位置信息
              let sections = element.sections
              let selectList =[]
              sections.forEach((element,index) => {
                let title = "第"+ (index + 1) + "题区"
                let id = index
                // 判断是否是选择题，是选择题的话需要另外渲染选择框
                let type = element.type
                let a = element.contents.position
                // 题块位置信息
                let point = {
                  id: id,
                  index: index,
                  title: title,
                  type: type,
                  left: a.left * this.width_sc + this.offsetLeft,
                  top: a.top * this.height_sc + this.offsetTop,
                  height: a.height * this.height_sc,
                  width: a.width * this.width_sc,
                  // 携带题号信息
                  branch: element.contents.branch,
                  // 获得换算过的高宽
                  width_old: a.width * this.width_sc,
                  height_old: a.height * this.height_sc,
                  scantron_width: a.width,
                  scantron_height: a.height
                }
                // postions.push(a)
                // 题区顺序 +1
                code ++
                postions.push(point)
                // selectList.push(point)
              });


              this.pageB = postions
            }
          });


          
          // this.$nextTick(() => {

          //   if(this.scantronType ==1){
          //     this.location = this.pageA
          //   }else{
          //     this.location = this.pageB
          //   }
          //   // 渲染选择题框
          //   this.getJsonByChoose()
          //   // 渲染学号
          //   this.getJsonByStudentNo()
          // })

          if(this.scantronType ==1){  

              this.location = this.pageA
            }else{
              this.location = this.pageB
            }

        },
        // 根据题目类型渲染选择框
        getJsonByChoose(){
   
          let chooseList = this.location.filter(item => item.type == 'Object')
          let width_sc = this.width_sc
          let height_sc = this.height_sc
          chooseList.forEach((element,index) => {
            
            // 获得题区的位置信息
            var canvas = document.getElementById("pc_"+element.id);
            let ctx = canvas.getContext('2d');
            canvas.width = element.width
            canvas.height = element.height
            canvas.style.left = element.left
            canvas.style.top = element.top
            console.log(canvas);

            let branch = element.branch
            branch.forEach((ele,index) => {
  
              // 渲染选择题区域
              let chooseCount = ele.chooseCount
              let postion  = ele.position
              let left_start = postion.left * width_sc
              let top_start = postion.top * height_sc
              let select_width = postion.width * width_sc
              let select_height = postion.width * width_sc
              ctx.beginPath();
              ctx.font = 'normal 10px Arial,sans-serif '; 
              ctx.strokeStyle = 'lightgreen';
              ctx.rect(left_start, top_start, select_width, select_height);
              ctx.stroke();

              // 渲染选择题
              // let perPre = (branch.subAreaTopicType=="Judge")?"PD":"P";
              let percent = this.percent["P"+ chooseCount];
              let ixList = ele.ixList
              // 选择框的y轴(默认行间隔)
              let y = height_sc * 1.5
              // 选择框的x轴（每个题区的起点）
              let x = index == 0 ? 0: left_start
              ixList.forEach((item,index) => {
                for (let k=0; k < percent.length; k++){
                  // let width = 5* width_sc
                  let height = 5 * height_sc

                  let left = percent[k][0] * select_width  
                  let left_end = percent[k][1] * select_width 
                  let width = left_end - left

                  let top = y + height * index

                  ctx.beginPath();
                  ctx.font = 'normal 10px Arial,sans-serif '; 
                  ctx.strokeStyle = 'lightgreen';
                  ctx.rect(left + x ,top+ top_start,width * 0.85 ,height * 0.85)
                  ctx.stroke();
                }
              });
            });
            
          });
        },
        getJsonByStudentNo(){
          // 学号等比例循环位数
          let ticketNum = this.location.filter(item => item.type == 'ticketNum')
          
          // 学号位数
          if(ticketNum.length == 1){
            let studentNo = ticketNum[0]
            let count = studentNo.count
            let firstOption = studentNo.firstOption
            // 获取画布,重置画布大小
            let id = studentNo.id
            var canvas = document.getElementById("pc_"+id);
            let ctx = canvas.getContext('2d');
            canvas.width = studentNo.width
            canvas.height = studentNo.height
            canvas.style.left = studentNo.left
            canvas.style.top = studentNo.top

            let width = studentNo.width
            let w = width / count
            let height = studentNo.height
            // let h = 5 * this.height_sc
            let h = height / 10

            // 学号从0~9 ，固定10行
            for(let i=0 ; i < count ; i ++){
              let x = i==0 ? width * 0.02 :  width * 0.02  + i*w 
              for(let j=0 ;j < 10 ; j++){
                let y = h*j
                ctx.beginPath();
                ctx.font = 'normal 10px Arial,sans-serif '; 
                ctx.strokeStyle = 'lightgreen';
                ctx.rect(x, y, w *0.85 , h *0.8 );
                ctx.stroke();
              }
            }
          }
        },
        // 调整大小，需要重新换算并画图
        onResize(pos,index){
      
          // 获取调整后的大小
          let item =  this.location[index]
          // 更新位置信息
          item.top = pos.top
          item.left = pos.left
          item.width = pos.width
          item.height = pos.height

          let type = item.type
          // if(type != 'Object') return
          
          if( type == 'Object'){
            let width = pos.width
            let height = pos.height
            let width_old = item.width_old
            let height_old = item.height_old
            let width_o_sc= width / width_old
            let height_o_sc = height / height_old
            let width_sc = this.width_sc
            let height_sc = this.height_sc

            var canvas = document.getElementById("pc_"+item.id);
            // 更新 canvas 的尺寸
            canvas.width = pos.width;
            canvas.height = pos.height;
            let ctx = canvas.getContext('2d');
            // 清空画布
            ctx.clearRect(0, 0, pos.width, pos.height);

            let branch = item.branch
            branch.forEach((ele,index) => {
          
              // 渲染选择题区域
              let chooseCount = ele.chooseCount
              let postion  = ele.position
              let left_start = postion.left * width_sc * width_o_sc
              let top_start = postion.top * height_sc * height_o_sc
              let select_width = postion.width * width_sc * width_o_sc
              let select_height = postion.width * width_sc * height_o_sc


              ctx.beginPath();
              ctx.font = 'normal 10px Arial,sans-serif '; 
              ctx.strokeStyle = 'lightgreen';
              ctx.rect(left_start, top_start, select_width, select_height);
              ctx.stroke();

              // 渲染选择题
              // let perPre = (branch.subAreaTopicType=="Judge")?"PD":"P";
              let percent = this.percent["P"+ chooseCount];
              let ixList = ele.ixList

              // 选择框的y轴(默认行间隔)
              let y = height_sc * 1.5
              // 选择框的x轴（每个题区的起点）
              let x = index == 0 ? 0: left_start

              ixList.forEach((item,index) => {
                for (let k=0; k < percent.length; k++){
                  // let width = 5* width_sc
                  let height = 5 * height_sc * height_o_sc
                  // let height_ = height / 8

                  let left = percent[k][0] * select_width  
                  let left_end = percent[k][1] * select_width 
                  let width = left_end - left

                  // 上下白边大概是占0.2
                  // 行间隔
                  // let spacer = height * 0.1   * index
                  let top = y + height   * index

                  ctx.beginPath();
                  ctx.font = 'normal 10px Arial,sans-serif '; 
                  ctx.strokeStyle = 'lightgreen';
                  ctx.rect(left + x ,top +top_start,width * 0.85 ,height * 0.85)
                  // ctx.rect(left + x ,top,width * 0.85 ,select_height * 0.55)
                  ctx.stroke();
                }
              });
            });
          }else if(type == 'ticketNum'){
            var canvas = document.getElementById("pc_"+item.id);
            // 更新 canvas 的尺寸
            canvas.width = pos.width;
            canvas.height = pos.height;
            let ctx = canvas.getContext('2d');
            // 清空画布
            ctx.clearRect(0, 0, pos.width, pos.height);

            let width_old = item.width_old
            let height_old = item.height_old

            // 计算显示高宽与原始渲染的大小
            let width_o_sc= pos.width / width_old
            let height_o_sc = pos.height / height_old

            // 学号位数
            let count = item.count 

            // 计算得出对应比例高宽
            // let width = pos.width * width_o_sc
            let w = width_old / count * width_o_sc
            // let height = pos.height * height_o_sc
            let h = height_old / 10 * height_o_sc

            // 学号从0~9 ，固定10行
            for(let i=0 ; i < count ; i ++){
              let x = i==0 ? width_old * 0.02 :  width_old * 0.02  + i*w 
              // let x =  i*w 
              for(let j=0 ;j < 10 ; j++){
                let y = h*j
                ctx.font = 'normal 10px Arial,sans-serif '; 
                ctx.strokeStyle = 'lightgreen';
                ctx.beginPath();
                ctx.rect(x, y, w *0.65 , h *0.8 );
                ctx.stroke();
              }
            }

          }else {
            return
          }

        },
        // 拖拽事件
        onDrag(pos,index){
        
          // 更新位置信息
          let item =  this.location[index]
          item.top = pos.top
          item.left = pos.left
          item.width = pos.width
          item.height = pos.height
        },
        // 保存
        saveLocation(value){
    
          // 判断是否点击
          if(this.location.length == 0){
            this.$message({ type: 'warning', message: '请选择答题卡正反面!',offset: 60});
            return
          }
          // 复原图像比例
          let location = JSON.parse(this.scantronInfo.location)
          console.log('location');
          console.log(location);
          // 题目内容
          let sections = location.pageSheets[this.pageNo].sections
          let item = this.location.filter(item => item.type != 'ticketNum' && item.type != 'barCode' && item.type != 'cheatMark' && item.type != 'absentMark' )
          item.forEach((element,index) => {
            // 题目是按照顺序提取的
            let section = sections[index].contents
            // 计算题区的位置信息（需删除偏移位置）
            section.position = {
              // top: (element.top - this.offsetTop )  / this.height_sc,
              // left: (element.left  - this.offsetLeft ) / this.width_sc,
              // width: element.width / this.width_sc,
              // height: element.height / this.height_sc

              top: (element.top)   / this.h_sc,
              left: (element.left) / this.w_sc,
              width: element.width / this.w_sc,
              height: element.height  / this.h_sc,
              scantron_width: element.scantron_width,
              scantron_height: element.scantron_height
            }
          });
          
          // 作弊位置
          let ch = this.location.filter(item => item.type == 'cheatMark' )
          if(ch.length == 1){
            let cheatMark = location.pageSheets[this.pageNo].cheatMark
            let position = cheatMark.position
            position = {
              // top: (ch[0].top - this.offsetTop  )  / this.height_sc,
              // left: (ch[0].left  - this.offsetLeft  ) / this.width_sc,
              // width: ch[0].width / this.width_sc,
              // height: ch[0].height / this.height_sc

              top: ch[0].top  / this.h_sc,
              left: ch[0].left  / this.w_sc,
              width: ch[0].width/ this.w_sc,
              height: ch[0].height  / this.h_sc,
              image_width: this.image_width,
              image_height: this.image_height,
              scantron_width: ch[0].scantron_width,
              scantron_height: ch[0].scantron_height
            }
            location.pageSheets[this.pageNo].cheatMark.position = position
  
          }
          
          // 缺考
          let ab = this.location.filter(item => item.type == 'absentMark' )
          if(ab.length == 1){
            let absentMark = location.pageSheets[this.pageNo].absentMark
            let position = absentMark.position
            position = {
              // top: (ab[0].top - this.offsetTop)  / this.height_sc,
              // left: (ab[0].left  - this.offsetLeft) / this.width_sc,
              // width: ab[0].width / this.width_sc,
              // height: ab[0].height / this.height_sc,

              // top: (ab[0].top - this.offsetTop  ) * this.h_sc  ,
              // left: (ab[0].left  - this.offsetLeft ) * this.w_sc,
              // width: ab[0].width * this.w_sc,
              // height: ab[0].height * this.h_sc,
              // image_width: this.image_width,
              // image_height: this.image_height

              top: ab[0].top / this.h_sc,
              left: ab[0].left / this.w_sc,
              // width: 800 / this.w_sc,
              width: ab[0].width / this.w_sc,
              // height: 820.5 / this.h_sc,
              height: ab[0].height / this.h_sc,
              image_width: this.image_width,
              image_height: this.image_height,
              scantron_width: ab[0].scantron_width,
              scantron_height: ab[0].scantron_height
            }
            location.pageSheets[this.pageNo].absentMark.position = position
          }

          // 学号位置
          let num = this.location.filter(item => item.type == 'ticketNum' )
          if(num.length == 1){
            let ticketNum = location.pageSheets[this.pageNo].ticketNum
            let position = ticketNum.position
            position = {
              // top: (num[0].top - this.offsetTop )  / this.height_sc,
              // left: (num[0].left  - this.offsetLeft ) / this.width_sc,
              // width: num[0].width / this.width_sc,
              // height: num[0].height / this.height_sc

              top: num[0].top  / this.h_sc,
              left: num[0].left/ this.w_sc,
              width: num[0].width / this.w_sc,
              height: num[0].height  / this.h_sc,
              scantron_width: num[0].scantron_width,
              scantron_height: num[0].scantron_height
            }
            location.pageSheets[this.pageNo].ticketNum.position = position
          }

          // 条形码位置
          let code = this.location.filter(item => item.type == 'barCode' )
          if(code.length == 1){
            let barCode = location.pageSheets[this.pageNo].barCode
            let position = barCode.position
            position = {
              // top: (code[0].top - this.offsetTop )  / this.height_sc,
              // left: (code[0].left  - this.offsetLeft ) / this.width_sc,
              // width: code[0].width / this.width_sc,
              // height: code[0].height / this.height_sc

              top: code[0].top  / this.h_sc,
              left: code[0].left/ this.w_sc,
              width: code[0].width / this.w_sc,
              height: code[0].height  / this.h_sc,
              scantron_width: code[0].scantron_width,
              scantron_height: code[0].scantron_height
            }
            location.pageSheets[this.pageNo].barCode.position = position
          }
         
          // 同一处理另外一面的答题卡json 格式
          let result = this.changeLocationByOther()
          if(result != null || result != undefined || result == ''){
            let pageNum = this.pageNo == 0 ? 1 : 0
            location.pageSheets[pageNum] = result.pageSheets[pageNum]
          }


          // 更新下cardInfo
          let json = JSON.stringify(location)

          let param = { 
            controllerName: 'scan/scanPre',
             methodName: '/immediatelyCut', 
             param: {
               id: this.scanPre.id,
               examId:  this.scanPre.exam_id,
               isBatch: value,
               seq: this.scanPre.seq,
               pageNo: this.pageNo +1 ,
               cardInfo: json,
               ossName:this.scanPre.oss_name,
               ossFullName:this.scanPre.oss_full_name,
               status:'SBS'}
              };
          simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
            if (code == 0) {
              this.$message({ type: 'success', message: '切图成功!',offset: 60});
              this.$parent.$parent.$parent.restartShow()
              // this.$emit('ok', status);
            }
          });

        },
        changeLocationByOther(){
          let location = JSON.parse(this.scantronInfo.location)

          let pageNum = this.pageNo == 0 ? 1 : 0
          if (location.pageSheets[pageNum] == null || location.pageSheets[pageNum] == undefined || location.pageSheets[pageNum] == '') return null
          let sections = location.pageSheets[pageNum].sections

          let item_other = pageNum == 1 ? this.pageB : this.pageA

          let item = item_other.filter(item => item.type != 'ticketNum' && item.type != 'barCode' && item.type != 'cheatMark' && item.type != 'absentMark' )
          item.forEach((element,index) => {
            // 题目是按照顺序提取的
            let section = sections[index].contents
            // 计算题区的位置信息（需删除偏移位置）
            section.position = {
              top: (element.top)   / this.h_sc,
              left: (element.left) / this.w_sc,
              width: element.width / this.w_sc,
              height: element.height  / this.h_sc,
              scantron_width: element.scantron_width,
              scantron_height: element.scantron_height
            }
          });
          
          // 作弊位置
          let ch = item_other.filter(item => item.type == 'cheatMark' )
          if(ch.length == 1){
            let cheatMark = location.pageSheets[pageNum].cheatMark
            let position = cheatMark.position
            position = {
              top: ch[0].top  / this.h_sc,
              left: ch[0].left  / this.w_sc,
              width: ch[0].width/ this.w_sc,
              height: ch[0].height  / this.h_sc,
              image_width: this.image_width,
              image_height: this.image_height,
              scantron_width: ch[0].scantron_width,
              scantron_height: ch[0].scantron_height
            }
            location.pageSheets[pageNum].cheatMark.position = position
  
          }

          // 缺考
          let ab = item_other.filter(item => item.type == 'absentMark' )
          if(ab.length == 1){
            let absentMark = location.pageSheets[pageNum].absentMark
            let position = absentMark.position
            position = {

              top: ab[0].top / this.h_sc,
              left: ab[0].left / this.w_sc,
              width: ab[0].width / this.w_sc,
              height: ab[0].height / this.h_sc,
              image_width: this.image_width,
              image_height: this.image_height,
              scantron_width: ab[0].scantron_width,
              scantron_height: ab[0].scantron_height
            }
            location.pageSheets[pageNum].absentMark.position = position
          }

          // 学号位置
          let num = item_other.filter(item => item.type == 'ticketNum' )
          if(num.length == 1){
            let ticketNum = location.pageSheets[pageNum].ticketNum
            let position = ticketNum.position
            position = {
              top: num[0].top  / this.h_sc,
              left: num[0].left/ this.w_sc,
              width: num[0].width / this.w_sc,
              height: num[0].height  / this.h_sc,
              scantron_width: num[0].scantron_width,
              scantron_height: num[0].scantron_height
            }
            location.pageSheets[pageNum].ticketNum.position = position
          }

          // 条形码位置
          let code = item_other.filter(item => item.type == 'barCode' )
          if(code.length == 1){
            let barCode = location.pageSheets[pageNum].barCode
            let position = barCode.position
            position = {
              top: code[0].top  / this.h_sc,
              left: code[0].left/ this.w_sc,
              width: code[0].width / this.w_sc,
              height: code[0].height  / this.h_sc,
              scantron_width: code[0].scantron_width,
              scantron_height: code[0].scantron_height
            }
            location.pageSheets[pageNum].barCode.position = position
          }
          return location
        },
        // 键盘移动事件
        handleKeyDown(event) {
          
          // this.$nextTick(() => {
          const { key, shiftKey } = event;
          let index = this.isActive
          let item =  this.location[index]
          let x = item.left
          let y = item.top

          const step = e.shiftKey ? this.step * 3 : this.step; // 按住Shift移动更快
          // 移动逻辑
          if (!shiftKey) {
            switch (key) {
              case 'w':
              case 'ArrowUp':
                // y -= this.step;
                item.top -= 1
                break;
              case 'a':
              case 'ArrowLeft':
                // x -= this.step;
                item.left -= 1
                break;
              case 's':
              case 'ArrowDown':
                // y += this.step;
                item.top += 1
                break;
              case 'd':
              case 'ArrowRight':
                item.left += 1
                // x += this.step;
                break;
              default:
                return; // 不是WASD键则不处理
            }
          }
        },
        // 当前选中
        setActiveItem(index) {
          this.isActive = index
        },
        // 获取答题卡信息（正背面定位点)
        getLocation(value){
          if(!this.loadingJson) {
            this.$message.warning('请稍等，答题卡加载中....')
            this.loadImage()
            this.getJsonByLocation()
            return
          }
          this.pageNo = value
          this.location = this.pageA
          if(value == 1){
            // 判断背面定位点是否存在
            if(this.pageB == null || this.pageB == undefined || this.pageB == '') {
              this.location = []
              this.$message.warning('背面定位点不存在，请查看绑定答题卡是否正确。')
              return
            }
            this.location = this.pageB
          }
          this.$nextTick(() => {
            // 渲染选择题框
            this.getJsonByChoose()
            // 渲染学号
            this.getJsonByStudentNo()
            this.$el.focus(); // 确保DOM更新完成
          })

        }
    }
  }
  </script>
  <style lang="scss" type="text/scss" rel="stylesheet/scss">
  
  .rectangle {
  width: 100%; /* 宽度占满父容器 */
  height: 100%; /* 高度占满父容器 */
  border: 2px solid #f35757; /* 边框 */
  /* background-color: rgba(255, 0, 0, 0.5);  */
  /* 背景颜色（半透明红色） */
  box-sizing: border-box; /* 确保边框不会影响尺寸 */
}

.top-left {  
  position: absolute; /* 设置绝对定位 */  
  top: -20px; /* 调整位置 */  
  left: -10px; /* 调整位置 */  
  font-size: 24px;
  color: rgb(5, 136, 252); /* 文字颜色，可自定义 */  
  /* background: rgba(0, 0, 0, 0.5);  */
  /* 文字背景 */  
  padding: 2px 5px; /* 外边距 */  
  border-radius: 3px; /* 边框圆角 */  
}  


.top-left-m {  
  position: absolute; /* 设置绝对定位 */  
  top: -20px; /* 调整位置 */  
  left: -10px; /* 调整位置 */  
  font-size: 15px;
  color: rgb(5, 136, 252); /* 文字颜色，可自定义 */  
  /* background: rgba(0, 0, 0, 0.5);  */
  /* 文字背景 */  
  padding: 2px 5px; /* 外边距 */  
  border-radius: 3px; /* 边框圆角 */  
}  

.container {
  width: 100%; /* 父容器的宽度 */
  height: auto; /* 高度自适应 */
}

.drawImage {
  max-width: 98%; /* 图片最大宽度为父容器的宽度 */
  max-height: 100%; /* 图片最大高度为父容器的高度 */
  height: auto; /* 保持图片的宽高比 */
  width: auto; /* 保持图片的宽高比 */
  margin: 10px;
}
  </style>